import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { RevenueByChannelStoreEffects } from './revenue.effects';
import { dashboardRevenueByChannelStoreFeatureKey, reducer } from './revenue.reducers';

export function provideRevenueByChannelStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(dashboardRevenueByChannelStoreFeatureKey, reducer),
    provideEffects([RevenueByChannelStoreEffects]),
  ]);
}
